import { useQuery } from "@tanstack/react-query";

import { ORDER } from "~/common/constants";
import { getPatientZoomMeetings } from "~/providers/api/patientZoomMeetingsService";

interface UseListPatientZoomMeetingsParams {
  patientId: string;
  orderBy?: string;
  order?: string;
  enabled?: boolean;
}

export const useListPatientZoomMeetings = ({
  patientId,
  orderBy = "scheduled_start_time",
  order = ORDER.descendant,
  enabled = true,
}: UseListPatientZoomMeetingsParams) => {
  return useQuery({
    queryFn: () =>
      getPatientZoomMeetings({
        patientId,
        order_by: orderBy,
        order,
      }),
    queryKey: ["getPatientZoomMeetings", patientId, orderBy, order],
    enabled: !!patientId && enabled,
  });
};
